const formatter = new Intl.NumberFormat('de-CH', { style: 'decimal', maximumFractionDigits: 0 });
export const formatNumber = (value) => formatter.format(value);
